import React, { useContext, useState } from "react";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import mixpanel from "mixpanel-browser";

import { auth } from "_firebase";

import { logoutUserAPI } from "utils/auth/api";
import { useOutsideClickHook } from "utils/outsideClick";

import { AuthContext } from "features/Auth";

import Dropdown from "components/Dropdown";
import CreditsTopBar from "components/CreditsTopBar";
import UnverifiedUserNotice from "components/UnverifiedUserNotice";

import classes from "./style.module.scss";

import ArrowIcon from "assets/images/icons/JSX/arrow-down";
import Avatar from "assets/images/icons/JSX/Avatar_Temp";
import HelpIcon from "assets/images/icons/JSX/Help";
import BellIcon from "assets/images/icons/JSX/Bell";
import BookIcon from "assets/images/icons/JSX/Book";

const DocumentationNav = ({ open, close }) => (
    <Dropdown
        open={open}
        className={classes.resourceDropdown}
        options={[
            {
                label: "Emission Factors",
                onClick: () => {
                    window.open("/documentation/emission-factors", "_blank", "noopener noreferrer");
                    mixpanel.track("Documentation Nav Click", {
                        Name: "Emission Factors",
                    });
                    close();
                },
            },
        ]}
    />
);

const ResourceNav = ({ open, close }) => (
    <Dropdown
        open={open}
        className={classes.resourceDropdown}
        options={[
            {
                label: "Pricing",
                onClick: () => {
                    window.open("/pricing", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Pricing",
                    });
                    close();
                },
            },
            {
                label: "Quick Start",
                onClick: () => {
                    window.open("/resources/quickstart", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Quick Start",
                    });
                    close();
                },
            },
            {
                label: "FAQs",
                onClick: () => {
                    window.open("/resources/faqs", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "FAQs",
                    });
                    close();
                },
            },
            {
                label: "Contact Us",
                onClick: () => {
                    window.open("/resources/contact", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Contact Us",
                    });
                    close();
                },
            },
            // {
            //     label: "Product Roadmap",
            //     onClick: () => {
            //         window.open("/resources/roadmap", "_blank", "noopener noreferrer");
            //         mixpanel.track("Resource Nav Click", {
            //             Name: "Product Roadmap",
            //         });
            //         close();
            //     },
            // },
            // {
            //     label: "Terms and Conditions",
            //     onClick: () => {
            //         window.open(
            //             "https://drive.google.com/file/d/1cxMLeiix0V5aJe80PTMAyeJeF-eKrUKY/view?usp=sharing",
            //             "_blank",
            //             "noopener noreferrer"
            //         );
            //         mixpanel.track("Resource Nav Click", {
            //             Name: "Terms and Conditions",
            //         });
            //         close();
            //     },
            //     hasDivider: true,
            // },
            // {
            //     label: "Privacy Policy",
            //     onClick: () => {
            //         window.open(
            //             "https://drive.google.com/file/d/1uCB8yeByjenPiu-GdSJN1d5mmLCTIvWp/view?usp=sharing",
            //             "_blank",
            //             "noopener noreferrer"
            //         );
            //         mixpanel.track("Resource Nav Click", {
            //             Name: "Privacy Policy",
            //         });
            //         close();
            //     },
            // },
            {
                label: "Terms and Conditions",
                onClick: () => {
                    window.open("/resources/terms", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Terms and Conditions",
                    });
                    close();
                },
                hasDivider: true,
            },
            {
                label: "Privacy Policy",
                onClick: () => {
                    window.open("/resources/privacy", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Privacy Policy",
                    });
                    close();
                },
            },
            {
                label: "Software Licensing Agreement",
                onClick: () => {
                    window.open("/resources/licence", "_blank", "noopener noreferrer");
                    mixpanel.track("Resource Nav Click", {
                        Name: "Software Licensing Agreement",
                    });
                    close();
                },
            },
        ]}
    />
);

const UserNav = ({ open, toggleUserNav, organizations, primaryOrg }) => {
    const history = useHistory();

    const { setUser } = useContext(AuthContext);

    const currentOrg = primaryOrg ? primaryOrg : !isEmpty(organizations) ? Object.keys(organizations)[0] : "";

    return (
        <Dropdown
            open={open}
            className={classes.userDropdown}
            options={[
                {
                    label: "Preferences",
                    onClick: () => {
                        history.push("/user/preferences");
                        toggleUserNav(false);
                    },
                },
                {
                    label: "Account",
                    onClick: () => {
                        history.push("/user/account");
                        toggleUserNav(false);
                    },
                },
                {
                    label: "Organization",
                    onClick: () => {
                        history.push(`/user/organization${currentOrg ? `/${currentOrg}` : ""}`);
                        toggleUserNav(false);
                    },
                    disabled: !currentOrg,
                },
                {
                    label: "Logout",
                    onClick: async () => {
                        document.body.style.cursor = "progress";

                        try {
                            mixpanel.track("Logout");
                            mixpanel.reset();

                            await logoutUserAPI();
                            await auth.signOut();

                            localStorage.removeItem("wasLoggedIn");
                            setUser(null);

                            history.replace("/login");
                        } finally {
                            document.body.style.cursor = "default";
                        }
                    },
                },
            ]}
        />
    );
};

export default ({ name, modelName, organizations, primaryOrg, allowPayments = false }) => {
    const [openDocumentationNav, toggleDocumentationNav] = useState(false);
    const [openResourceNav, toggleResourceNav] = useState(false);
    const [openUserNav, toggleUserNav] = useState(false);
    const documentationRef = useOutsideClickHook(() => toggleDocumentationNav(false));
    const resourceRef = useOutsideClickHook(() => toggleResourceNav(false));
    const userRef = useOutsideClickHook(() => toggleUserNav(false));

    return (
        <div className={classes.topBar}>
            {
                // modelName &&
                //     <div className={classes.breadCrumb}>
                //         <span>House Models</span>
                //         <ArrowDown />
                //         <span>{modelName}</span>
                //     </div>
            }
            <div className={classes.headerRight}>
                <UnverifiedUserNotice />
                {allowPayments && <CreditsTopBar allowPayments={allowPayments} />}
                <div className={classes.documentationNav} ref={documentationRef}>
                    <p
                        className={openDocumentationNav ? classes.open : ""}
                        onClick={() => toggleDocumentationNav(!openDocumentationNav)}
                    >
                        <BookIcon /> Documentation{" "}
                        <span className={classes.arrow}>
                            <ArrowIcon />
                        </span>
                    </p>
                    <DocumentationNav open={openDocumentationNav} close={() => toggleDocumentationNav(false)} />
                </div>
                <div className={classes.updates}>
                    <p onClick={() => window.open("/updates", "_blank", "noopener noreferrer")}>
                        <BellIcon /> Updates
                    </p>
                </div>
                <div className={classes.resourceNav} ref={resourceRef}>
                    <p
                        className={openResourceNav ? classes.open : ""}
                        onClick={() => toggleResourceNav(!openResourceNav)}
                    >
                        <HelpIcon /> Resources{" "}
                        <span className={classes.arrow}>
                            <ArrowIcon />
                        </span>
                    </p>
                    <ResourceNav open={openResourceNav} history={history} close={() => toggleResourceNav(false)} />
                </div>
                <div className={classes.userNav} ref={userRef}>
                    <Avatar />
                    <p className={openUserNav ? classes.open : ""} onClick={() => toggleUserNav(!openUserNav)}>
                        {name}
                    </p>
                    <UserNav
                        open={openUserNav}
                        toggleUserNav={toggleUserNav}
                        history={history}
                        organizations={organizations}
                        primaryOrg={primaryOrg}
                    />
                </div>
            </div>
        </div>
    );
};
